import React from 'react';

import { ModalDialogType } from '@eika/modal';

import type { Account, AccountNumber } from '../../generated-types';
import { EikaModal } from '../EikaModal';
import AccountList from './AccountList';
import AccountListInvalid from './AccountListInvalid';
import AccountListSkeleton from './AccountListSkeleton';

type RequestExceptionWithResponse = import('@eika-infrastruktur/request').RequestExceptionWithResponse;

interface Props {
    id: string;
    title?: string;
    retry: () => void;
    isLoading?: boolean;
    onChange: (newAccountNumber: AccountNumber) => void;
    error?: RequestExceptionWithResponse;
    accounts?: Account[];
    invalidAccounts?: Account[];
    show: boolean;
    setShow: React.Dispatch<boolean>;
    animateAs?: ModalDialogType;
    showNegativeAmount?: boolean;
}

const SelectAccountModal: React.FC<Props> = ({
    id,
    title,
    retry,
    isLoading,
    error,
    accounts,
    invalidAccounts,
    show,
    setShow,
    onChange,
    animateAs,
    showNegativeAmount = false,
}) => {
    return (
        <EikaModal id={id} open={show} setOpen={setShow} title={!error ? title : ''} animateAs={animateAs}>
            {isLoading ? (
                <AccountListSkeleton count={7} />
            ) : (
                <>
                    <AccountList
                        error={error}
                        retry={retry}
                        accounts={accounts}
                        onClick={onChange}
                        showNegativeAmount={showNegativeAmount}
                    />

                    {invalidAccounts && (
                        <AccountListInvalid
                            error={error}
                            retry={retry}
                            accounts={invalidAccounts}
                            showNegativeAmount={showNegativeAmount}
                        />
                    )}
                </>
            )}
        </EikaModal>
    );
};

export default SelectAccountModal;
